<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Toasted from "vue-toasted";

Vue.use(Toasted);

/**
 * Abonar a cuenta: busca el cliente, muestra el saldo total de sus creditos de
 * venta Y de taller, y permite abonar un monto que el backend reparte FIFO
 * (mas viejo primero) de forma unificada sobre ambos tipos de credito.
 */
export default {
  page: {
    title: "Abonar a cuenta",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    vSelect,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      apiUrl: process.env.VUE_APP_URL,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      title: "Abonar a cuenta",
      items: [
        { text: "Ventas", href: "/" },
        { text: "Abonar a cuenta", active: true },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      metodosPago: [
        { value: "efectivo", text: "Efectivo" },
        { value: "transferencia", text: "Transferencia" },
        { value: "deposito", text: "Depósito" },
        { value: "cheque", text: "Cheque" },
        { value: "tarjeta", text: "Tarjeta" },
      ],
      // Cliente
      arrayClientes: [],
      clienteSel: null,
      clienteData: null,
      // Creditos del cliente (venta y taller)
      creditos: [],
      creditosTaller: [],
      totalSaldo: 0,
      totalSaldoTaller: 0,
      cargando: false,
      // Caja
      validateArqueo: false,
      dataCierre: null,
      // Modal abono (un solo metodo por abono)
      showModalAbono: false,
      guardando: false,
      generandoPdf: false,
      pago: {
        metodo: "efectivo",
        monto: "",
        transaccion: "",
      },
      // Resultado del abono (recibo)
      resultado: null,
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    }
    this.validarCaja();
  },
  computed: {
    saldoGeneral() {
      const v =
        (parseFloat(this.totalSaldo) || 0) + (parseFloat(this.totalSaldoTaller) || 0);
      return Math.round((v + Number.EPSILON) * 100) / 100;
    },
    totalCreditos() {
      return this.creditos.length + this.creditosTaller.length;
    },
    totalAbono() {
      const v = parseFloat(this.pago.monto) || 0;
      return Math.round((v + Number.EPSILON) * 100) / 100;
    },
    saldoRestante() {
      const r = this.saldoGeneral - this.totalAbono;
      return Math.round((r + Number.EPSILON) * 100) / 100;
    },
    excedeSaldo() {
      return this.totalAbono > this.saldoGeneral + 0.001;
    },
    restanteNegativo() {
      return this.saldoRestante < 0;
    },
    saldoRestanteMostrar() {
      return this.saldoRestante < 0 ? 0 : this.saldoRestante;
    },
    requiereReferencia() {
      return this.pago.metodo !== "efectivo";
    },
  },
  methods: {
    money(value) {
      return (
        "Q " +
        parseFloat(value || 0)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    iniciales(nombre) {
      if (!nombre) return "?";
      return nombre.trim().charAt(0).toUpperCase();
    },
    nombreCliente() {
      if (!this.clienteData || !this.clienteData.persona) return "";
      const p = this.clienteData.persona;
      return (p.nombre_persona || "") + " " + (p.apellido_persona || "");
    },
    validarCaja() {
      axios
        .get(
          this.apiUrl +
            "caja/get_validate?&usuario=" +
            this.userT.id +
            "&tienda=" +
            this.userT.tienda,
          this.httpOptions
        )
        .then((response) => {
          this.validateArqueo =
            response.data.validate == "null" ||
            response.data.validate == "" ||
            response.data.validate == null
              ? false
              : true;
          this.dataCierre = response.data.validate;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getClientes(search, loading) {
      if (loading) loading(true);
      axios
        .get(
          this.apiUrl + "clientes/busqueda?search=" + encodeURIComponent(search || ""),
          this.httpOptions
        )
        .then((response) => {
          this.arrayClientes = response.data || [];
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (loading) loading(false);
        });
    },
    onSelectCliente(cliente) {
      this.creditos = [];
      this.creditosTaller = [];
      this.totalSaldo = 0;
      this.totalSaldoTaller = 0;
      this.clienteData = null;
      this.resultado = null;
      if (!cliente) return;
      this.cargarCreditos(cliente.id);
    },
    // Reutiliza clientes/get_saldos (devuelve ventas y taller)
    cargarCreditos(id) {
      this.cargando = true;
      axios
        .get(this.apiUrl + "clientes/get_saldos?id=" + id, this.httpOptions)
        .then((response) => {
          this.clienteData = response.data.cliente;
          this.creditos = response.data.SaldosVenta || [];
          this.totalSaldo = parseFloat(response.data.totalSaldoCredito) || 0;
          this.creditosTaller = response.data.SaldosVentaTaller || [];
          this.totalSaldoTaller =
            parseFloat(response.data.totalSaldoCreditoTaller) || 0;
        })
        .catch((error) => {
          console.log(error);
          Vue.toasted.error("No se pudieron cargar los créditos", this.options);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    abrirModalAbono() {
      if (!this.validateArqueo) {
        Vue.toasted.error(
          "No tienes una caja abierta. Inicia caja para poder abonar.",
          this.options
        );
        return;
      }
      if (!this.totalCreditos || this.saldoGeneral <= 0) {
        Vue.toasted.error("El cliente no tiene saldo pendiente", this.options);
        return;
      }
      this.resultado = null;
      this.pago = { metodo: "efectivo", monto: "", transaccion: "" };
      this.showModalAbono = true;
    },
    construirMontos() {
      const base = {
        monto_efectivo: "",
        monto_deposito: [],
        monto_cheque: [],
        monto_transferencia: [],
        monto_tarjeta: [],
      };
      const monto = parseFloat(this.pago.monto) || 0;
      if (monto <= 0) return base;
      const ref = this.pago.transaccion;
      switch (this.pago.metodo) {
        case "efectivo":
          base.monto_efectivo = monto;
          break;
        case "deposito":
          base.monto_deposito = [{ monto_deposito: monto, transaccion_deposito: ref }];
          break;
        case "cheque":
          base.monto_cheque = [{ monto_cheque: monto, transaccion_cheque: ref }];
          break;
        case "transferencia":
          base.monto_transferencia = [
            { monto_transferencia: monto, transaccion_transferencia: ref },
          ];
          break;
        case "tarjeta":
          base.monto_tarjeta = [{ monto_tarjeta: monto, transaccion_tarjeta: ref }];
          break;
      }
      return base;
    },
    guardarAbono() {
      if (this.totalAbono <= 0) {
        Vue.toasted.error("Ingrese un monto a abonar", this.options);
        return;
      }
      if (this.excedeSaldo) {
        Vue.toasted.error(
          "El abono supera el saldo total del cliente",
          this.options
        );
        return;
      }
      this.guardando = true;
      axios
        .post(
          this.apiUrl + "cuenta/abonar",
          {
            cliente: this.clienteSel.id,
            usuario: this.userT.id,
            caja: this.dataCierre.id,
            tienda: this.userT.tienda,
            montos: this.construirMontos(),
          },
          this.httpOptions
        )
        .then((response) => {
          this.resultado = response.data;
          Vue.toasted.success("Abono registrado correctamente", this.options);
          this.showModalAbono = false;
          this.cargarCreditos(this.clienteSel.id);
        })
        .catch((error) => {
          const msg =
            (error.response && error.response.data && error.response.data.msg) ||
            "Error al registrar el abono";
          Vue.toasted.error(msg, this.options);
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    // Descarga el recibo PDF (con token via blob, no window.open directo)
    descargarRecibo(id) {
      if (this.generandoPdf) return;
      this.generandoPdf = true;
      axios
        .get(this.apiUrl + "cuenta/recibo?id=" + id, {
          headers: this.httpOptions.headers,
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch((error) => {
          console.log(error);
          Vue.toasted.error("No se pudo generar el recibo", this.options);
        })
        .finally(() => {
          this.generandoPdf = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- Buscador de cliente -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-lg-7">
                <label class="form-label fw-semibold mb-1">
                  <i class="bx bx-search-alt text-primary"></i> Buscar cliente
                </label>
                <v-select
                  v-model="clienteSel"
                  :options="arrayClientes"
                  label="nombre"
                  :filterable="false"
                  placeholder="Escribe el nombre o NIT del cliente..."
                  @search="getClientes"
                  @input="onSelectCliente"
                >
                  <template #no-options>Escribe para buscar un cliente</template>
                </v-select>
              </div>
              <div class="col-lg-5 mt-3 mt-lg-0">
                <div
                  v-if="!validateArqueo"
                  class="alert alert-warning d-flex align-items-center mb-0"
                  role="alert"
                >
                  <i class="mdi mdi-alert-outline fs-4 me-2"></i>
                  <div>
                    <strong>Sin caja abierta.</strong> Debes iniciar caja para
                    poder registrar abonos.
                  </div>
                </div>
                <div
                  v-else
                  class="alert alert-success d-flex align-items-center mb-0"
                  role="alert"
                >
                  <i class="mdi mdi-cash-register fs-4 me-2"></i>
                  <div>Caja abierta — listo para cobrar.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="text-center my-5">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem"></b-spinner>
      <p class="text-muted mt-2">Cargando estado de cuenta...</p>
    </div>

    <!-- Estado de cuenta -->
    <div v-else-if="clienteSel && totalCreditos" class="row">
      <!-- Resumen del cliente -->
      <div class="col-xl-4">
        <div class="card bg-primary bg-gradient text-white">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-sm me-3">
                <span
                  class="avatar-title rounded-circle bg-white text-primary fs-4 fw-bold"
                >
                  {{ iniciales(clienteData && clienteData.persona ? clienteData.persona.nombre_persona : "") }}
                </span>
              </div>
              <div>
                <h5 class="text-white mb-0">{{ nombreCliente() }}</h5>
                <small class="text-white-50" v-if="clienteData">
                  NIT: {{ clienteData.nit_cliente || "C/F" }}
                </small>
              </div>
            </div>
            <hr class="border-light opacity-50" />
            <p class="text-white-50 mb-1">Saldo total pendiente</p>
            <h2 class="text-white mb-3">{{ money(saldoGeneral) }}</h2>
            <div class="d-flex justify-content-between text-white-50 small mb-1">
              <span><i class="bx bx-cart"></i> Ventas ({{ creditos.length }})</span>
              <span>{{ money(totalSaldo) }}</span>
            </div>
            <div class="d-flex justify-content-between text-white-50 small mb-3">
              <span><i class="bx bx-wrench"></i> Taller ({{ creditosTaller.length }})</span>
              <span>{{ money(totalSaldoTaller) }}</span>
            </div>
            <b-button
              variant="light"
              size="lg"
              class="w-100 fw-semibold text-primary"
              :disabled="!validateArqueo"
              @click="abrirModalAbono"
            >
              <i class="mdi mdi-cash-multiple me-1"></i> Abonar a cuenta
            </b-button>
          </div>
        </div>

        <!-- Recibo del último abono -->
        <div v-if="resultado" class="card border border-success">
          <div class="card-body">
            <h5 class="card-title text-success">
              <i class="mdi mdi-check-circle"></i> Abono registrado
            </h5>
            <div class="d-flex justify-content-between">
              <span class="text-muted">Monto abonado</span>
              <strong>{{ money(resultado.monto_total) }}</strong>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted">Saldo restante</span>
              <strong>{{ money(resultado.saldo_total_nuevo) }}</strong>
            </div>
            <hr />
            <p class="text-muted mb-2 small">Aplicado a:</p>
            <ul class="list-unstyled mb-3">
              <li
                v-for="(d, i) in resultado.detalle"
                :key="i"
                class="d-flex justify-content-between align-items-center mb-1"
              >
                <span>
                  <i :class="d.tipo === 'taller' ? 'bx bx-wrench' : 'bx bx-cart'"></i>
                  {{ d.tipo === "taller" ? "Servicio" : "Venta" }} {{ d.no_documento }}
                </span>
                <span>
                  {{ money(d.monto_aplicado) }}
                  <span v-if="d.pagado_total" class="badge bg-success ms-1">Saldado</span>
                </span>
              </li>
            </ul>
            <b-button
              variant="outline-primary"
              size="sm"
              class="w-100"
              :disabled="generandoPdf"
              @click="descargarRecibo(resultado.abonoId)"
            >
              <b-spinner small v-if="generandoPdf" class="me-1"></b-spinner>
              <i v-else class="mdi mdi-file-pdf-box me-1"></i>
              {{ generandoPdf ? "Generando PDF..." : "Imprimir recibo (PDF)" }}
            </b-button>
          </div>
        </div>
      </div>

      <!-- Tablas de creditos -->
      <div class="col-xl-8">
        <!-- Ventas -->
        <div class="card" v-if="creditos.length">
          <div class="card-body">
            <h5 class="card-title mb-3">
              <i class="bx bx-cart text-primary"></i> Créditos de venta
            </h5>
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>No. Venta</th>
                    <th>Fecha</th>
                    <th>Vence</th>
                    <th class="text-end">Total</th>
                    <th class="text-end">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, i) in creditos" :key="i">
                    <td>
                      <span class="badge bg-primary bg-soft text-primary">
                        {{ c.no_ducumento_v }}
                      </span>
                    </td>
                    <td class="text-muted">{{ c.fecha_venta_v }}</td>
                    <td class="text-muted">{{ c.fecha_credito_v || "—" }}</td>
                    <td class="text-end">{{ money(c.total_v) }}</td>
                    <td class="text-end">
                      <strong class="text-danger">{{ money(c.saldo_credito_v) }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr>
                    <th colspan="4" class="text-end">Subtotal ventas</th>
                    <th class="text-end text-danger">{{ money(totalSaldo) }}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- Taller -->
        <div class="card" v-if="creditosTaller.length">
          <div class="card-body">
            <h5 class="card-title mb-3">
              <i class="bx bx-wrench text-primary"></i> Créditos de taller
            </h5>
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>No. Servicio</th>
                    <th>Fecha</th>
                    <th>Vence</th>
                    <th class="text-end">Total</th>
                    <th class="text-end">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, i) in creditosTaller" :key="i">
                    <td>
                      <span class="badge bg-warning bg-soft text-warning">
                        {{ c.no_servicio }}
                      </span>
                    </td>
                    <td class="text-muted">{{ c.fecha_entrada }}</td>
                    <td class="text-muted">{{ c.fecha_credito || "—" }}</td>
                    <td class="text-end">{{ money(c.total) }}</td>
                    <td class="text-end">
                      <strong class="text-danger">{{ money(c.saldo_credito) }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr>
                    <th colspan="4" class="text-end">Subtotal taller</th>
                    <th class="text-end text-danger">{{ money(totalSaldoTaller) }}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sin creditos -->
    <div
      v-else-if="clienteSel && !totalCreditos && !cargando"
      class="row"
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body text-center py-5">
            <i class="bx bx-check-circle text-success" style="font-size: 3rem"></i>
            <h5 class="mt-2">Sin créditos pendientes</h5>
            <p class="text-muted mb-0">
              Este cliente no tiene créditos de venta ni de taller por cobrar.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado inicial -->
    <div v-else-if="!clienteSel" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body text-center py-5 text-muted">
            <i class="bx bx-user-circle" style="font-size: 3rem"></i>
            <p class="mt-2 mb-0">Busca un cliente para ver su estado de cuenta.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Abono -->
    <b-modal
      v-model="showModalAbono"
      centered
      title="Abonar a cuenta"
      title-class="text-black font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div class="alert alert-info d-flex align-items-center" role="alert">
        <i class="mdi mdi-information-outline fs-4 me-2"></i>
        <div>
          El abono se aplica automáticamente del crédito
          <strong>más antiguo al más reciente</strong> (ventas y taller juntos).
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold">Método de pago</label>
        <select class="form-select" v-model="pago.metodo">
          <option v-for="m in metodosPago" :key="m.value" :value="m.value">
            {{ m.text }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold">Monto a abonar</label>
        <div class="input-group">
          <span class="input-group-text">Q</span>
          <input
            type="number"
            min="0"
            step="0.01"
            class="form-control"
            placeholder="0.00"
            v-model="pago.monto"
          />
        </div>
      </div>

      <div class="mb-3" v-if="requiereReferencia">
        <label class="form-label fw-semibold">No. de transacción / referencia</label>
        <input
          type="text"
          class="form-control"
          placeholder="Ingrese la referencia"
          v-model="pago.transaccion"
        />
      </div>

      <!-- Resumen -->
      <div class="card bg-light mt-1 mb-0">
        <div class="card-body py-3">
          <div class="row text-center">
            <div class="col-4 border-end">
              <p class="text-muted mb-1 small">Saldo total</p>
              <h5 class="mb-0">{{ money(saldoGeneral) }}</h5>
            </div>
            <div class="col-4 border-end">
              <p class="text-muted mb-1 small">A abonar</p>
              <h5 class="mb-0" :class="excedeSaldo ? 'text-danger' : 'text-success'">
                {{ money(totalAbono) }}
              </h5>
            </div>
            <div class="col-4">
              <p class="text-muted mb-1 small">Quedará</p>
              <h5 class="mb-0" :class="{ 'text-danger': restanteNegativo }">
                {{ money(saldoRestanteMostrar) }}
              </h5>
            </div>
          </div>
          <div v-if="excedeSaldo" class="text-danger text-center small mt-2">
            <i class="mdi mdi-alert"></i> El abono supera el saldo total del cliente.
          </div>
        </div>
      </div>

      <div class="text-end mt-3">
        <b-button variant="light" @click="showModalAbono = false">Cancelar</b-button>
        <b-button
          variant="success"
          class="ms-1"
          :disabled="guardando || totalAbono <= 0 || excedeSaldo"
          @click="guardarAbono"
        >
          <b-spinner small v-if="guardando"></b-spinner>
          <i v-else class="mdi mdi-check me-1"></i>
          Confirmar abono
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.avatar-sm {
  height: 3rem;
  width: 3rem;
}
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
